import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-plan-accion-panel-iot-form',
  templateUrl: './plan-accion-panel-iot-form.component.html',
  styleUrls: ['./plan-accion-panel-iot-form.component.css']
})
export class PlanAccionPanelIotFormComponent implements OnInit {

  ngOnInit() {
  }

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<PlanAccionPanelIotFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      poza: [''],
      ctp: [''],
      lectura: [''],
      limites: [''],
      valor: [''],
      descripcion: ['']
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

}
